// extracted by mini-css-extract-plugin
module.exports = {"content_wrap_sidebar_head":"MenuItems_content_wrap_sidebar_head__3uzG-","selected":"MenuItems_selected__33Hij"};